export const FORM_NAME = 'DELETE_REASON'
export const style22 = { width: '22%' }
export const style75 = { width: '75%' }
export const style100 = { width: '100%' }
